// AlertModal.tsx
import React from 'react';
import global from '../../../styles/index.module.scss';
import styles from './AlertModal.module.scss';

interface AlertModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const AlertModal: React.FC<AlertModalProps> = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <p className={styles.modalTitle}>該当のSTEPに移動しますか？</p>
        <p className={styles.modalText}>入力内容はリセットされます</p>
        <div className={styles.buttonWrapper}>
          <button onClick={onConfirm} className={global.primaryButton}>該当のSTEPに移動する</button>
        </div>
        <button onClick={onClose} className={styles.modalBack}>現在の画面に留まる</button>
      </div>
    </div>
  );
};